const SET_UTILITY_ANNUAL_INFLATION = 'SET_UTILITY_ANNUAL_INFLATION';
const SET_UTILITY_ANNUAL_KWH = 'SET_UTILITY_ANNUAL_KWH';
const SET_UTILITY_ENERGY_VALUE = 'SET_UTILITY_ENERGY_VALUE';
const SET_UTILITY_PROVIDER = 'SET_UTILITY_PROVIDER';
const SET_UTILITY_ANNUAL_A_FIXED_CHARGE = 'SET_UTILITY_ANNUAL_A_FIXED_CHARGE';
const SET_UTILITY_MONTHLY_KWH_INPUTS = 'SET_UTILITY_MONTHLY_KWH_INPUTS';
const SET_UTILITY_MONTHLY_FIXED_INPUTS = 'SET_UTILITY_MONTHLY_FIXED_INPUTS';
const SET_UTILITY = 'SET_UTILITY';

export {
    SET_UTILITY_ANNUAL_INFLATION,
    SET_UTILITY_ANNUAL_KWH,
    SET_UTILITY_ENERGY_VALUE,
    SET_UTILITY_PROVIDER,
    SET_UTILITY_ANNUAL_A_FIXED_CHARGE,
    SET_UTILITY_MONTHLY_KWH_INPUTS,
    SET_UTILITY_MONTHLY_FIXED_INPUTS,
    SET_UTILITY,
};



// WEBPACK FOOTER //
// ./src/containers/common/utility/constants.js